export default __webpack_public_path__ + "static/media/No60Open.741d4ef9.jpg";